<template>
  <div class="toolbox-buttons">
    <v-btn
      v-for="(button, index) in buttons"
      :key="index"
      size="small"
      class="mr-4"
      :variant="button.variant"
      :data-testid="`toolbox-button-${button.name}`"
      :disabled="button.disabled"
      @click.stop="handleClick(button.name)"
    >
      {{ button.name }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'ToolboxButtons',
  props: {
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['buttonClicked'],
  methods: {
    handleClick(name) {
      this.$emit('buttonClicked', name);
    },
  },
};
</script>

<style scoped lang="scss">
.toolbox-buttons {
  background-color: #FFF;
  width: 100%;
  height: 45px;
  display: inline-flex;
  justify-content: left;
  align-items: center;
  padding-left: 10px;
  border-radius: 5px;
}
</style>

